// Map Firebase Auth error codes to friendly copy.
export function authErrorToMessage(code) {
  switch (code) {
    case "auth/email-already-in-use":
      return "This email’s already on-board, Explorer! Try signing in instead.";
    case "auth/invalid-email":
      return "Oops - that doesn’t look like a valid email. Give it another shot!";
    case "auth/weak-password":
      return "Power up your password! It needs to be stronger.";
    case "auth/popup-closed-by-user":
      return "Sign-in window closed mid-flight. Try again when you’re ready.";
    case "auth/account-exists-with-different-credential":
      return "You previously used another sign-in method. Try that route again!";
    case "auth/network-request-failed":
      return "Network turbulence detected. Check your connection and retry.";
    case "auth/popup-blocked":
      return "Your browser blocked the Google sign-in window. Redirecting you to Google sign-in instead.";
    case "auth/unauthorized-domain":
      return "Google sign-in is not authorized for this website domain.";
    case "auth/operation-not-allowed":
      return "Google sign-in is currently unavailable. Please contact Teleport Now support.";
    case "auth/invalid-credential":
      return "Google could not verify this sign-in. Please choose your account again.";
    default:
      return null;
  }
}
